<template>
  <vs-popup
    title="Pagamentos Inconsistentes"
    :active.sync="showModal"
    @close="handleHideNotification"
    class="modal_pagamento_inconsistente"
  >
    <div class="modal__content">
      <feather-icon icon="AlertCircleIcon" svgClasses="h-12 w-12 alert" />
      <span
        class="modal__content__text"
        v-if="countPagamentosInconsistentes == 1"
      >
        {{ countPagamentosInconsistentes }} Boleto encontrado com pagamento
        inconsistente
      </span>
      <span class="modal__content__text" v-else>
        {{ countPagamentosInconsistentes }} Boletos encontrados com pagamento
        inconsistentes
      </span>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-button
          color="success"
          data-test="verificar"
          @click="handleVerificar"
        >
          Verificar
        </vs-button>

        <vs-button
          class="ml-4"
          color="warning"
          data-test="mostrar-depois"
          @click="handleHideNotification"
        >
          Mostrar depois
        </vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import notify from '../../../../utils/notify';
import services from '../../../../services';

export default {
  data() {
    return {
      showModal: false,
      countPagamentosInconsistentes: 0,
    };
  },
  methods: {
    async getCountPagamentosInconsistentes() {
      try {
        const response = await services.getAll(
          'pagamentos-inconsistentes',
          undefined,
          'count',
        );

        if (response.data) {
          const result = response.data;

          this.countPagamentosInconsistentes =
            result.countPagamentosInconsistentes;
        }
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      }
    },
    handleHideNotification() {
      this.showModal = false;
      localStorage.setItem('hideNotificationPagtoInconsistentes', '1');
    },
    handleVerificar() {
      this.handleHideNotification();
      this.$nextTick(() => {
        this.$router.push({
          path: 'pagamentos-inconsistentes',
        });
      });
    },
  },
  async mounted() {
    // #region Valida Permissão

    const permission = this.$can(
      'Notificar Pagamentos Inconsistentes',
      'Pagamentos Inconsistentes',
    );

    if (!permission) {
      return;
    }

    // #endregion

    // #region Valida se Notificação foi ocultada

    const hideNotification = localStorage.getItem(
      'hideNotificationPagtoInconsistentes',
    );

    if (hideNotification) {
      return;
    }

    //#endregion

    // #region Valida se existe pagamentos inconsistentes

    await this.getCountPagamentosInconsistentes();

    if (!this.countPagamentosInconsistentes) {
      return;
    }

    //#endregion

    this.showModal = true;
  },
};
</script>

<style lang="scss">
.alert {
  color: #ff6464;
}

.modal_pagamento_inconsistente {
  .vs-popup {
    width: auto !important;
  }
}
</style>

<style scoped lang="scss">
.modal__content {
  display: flex;
  align-items: center;
  margin-bottom: 32px;

  &__text {
    font-weight: 500;
    font-size: 1.2rem;
  }

  span {
    display: block;
    margin-left: 12px;
  }
}
</style>
